// 999 -> 999
// 9999 -> 9,999 (if 'formatSmallerNumToStandardNotation' is false, then 10K)
// 10000 -> 10K
// 12270 -> 12.3K
// 99999 -> 100K
// 108700 -> 108.7K
// 999999 -> 1M
// 1580000 -> 1.6M
// 9999999 -> 10M
// 10460000 -> 10.5M

import { formatNumToStandardNotation } from '@modules/common/utils';

interface FormatNumToCompactNotationParams {
  value: number;
  formatSmallerNumToStandardNotation?: boolean;
  maximumFractionDigits?: number;
}

export const formatNumToCompactNotation = ({
  value,
  formatSmallerNumToStandardNotation,
  maximumFractionDigits = 2,
}: FormatNumToCompactNotationParams): string | number => {
  if (value < 10000 && formatSmallerNumToStandardNotation) {
    return formatNumToStandardNotation(value);
  }

  return new Intl.NumberFormat('en-US', {
    notation: 'compact',
    compactDisplay: 'short',
    minimumFractionDigits: 0,
    maximumFractionDigits,
  }).format(value);
};
